import { AppModal } from "@/components";
import { Select } from "antd";
import { useTranslation } from "react-i18next";

type ModalData = { hide: () => void, open: boolean, setIsNewReserveMode: (value: boolean) => void };

export default function SelectReserveModeModal({ hide, open, setIsNewReserveMode }: ModalData) {
  const [t] = useTranslation(['common', 'reserve']);
  // const [isNewReserveMode, setIsNewReserveMode] = useLocalStorage('new-reserve-mode-api', false) ;

  const handleModeChange = (value) => {
    setIsNewReserveMode(value === "true");
    localStorage.setItem('new-reserve-mode-api', value === "true" ? "true" : "false");
    hide();
  };

  return (
    <AppModal
      centered
      destroyOnHidden
      open={open}
      footer={null}
      style={{ maxWidth: '90%' }}
      title={t(`reserve:labels.select-reserve-mode`)}
    >
      <div>
        <label htmlFor="select-reserve-mode">
        لطفا روش مورد نظر خود برای رزرو را انتخاب کنید. روش مورد نظر منظور این است که شما برای هر عدد رزرو یک کد تحویل دریافت کنید یا به ازای همه رزروها یک کد تحویل داشته باشید.

        </label>
        <Select
          size="large"
          className="text-sm w-full mb-4"
          defaultValue={null}
          onChange={handleModeChange}
          placeholder={t('reserve:labels.reserve-mode')}
          options={[
            { label: t('reserve:labels.default-reserve-mode'), value: "false" },
            { label: t('reserve:labels.new-reserve-mode'), value: "true" },
          ]}
        />
      </div>
    </AppModal>
  )
}
